import React from 'react';
import _ from 'lodash';

import { withFedopsLogger } from '@wix/yoshi-flow-editor';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logWidgetVidClick } from '../../../utils/bi/widget-common-events';
import { openFullScreenOverlay } from '../../../utils/open-overlay-base';
import focus from '@wix/wix-vod-shared/dist/esm/widget/utils/accessibility-focus';
import { storeForReload } from '../../../utils/reload';
import {
  getExpandedViewTheme,
  canShowExpandedVideoShare,
  isRTL,
  isCompactMainActionsOnlyIcons,
} from '../../../selectors/app-settings';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import { getVideosGroupedByIds } from '../../../selectors/videos';
import { getCurrentSiteUser } from '../../../selectors/current-site-user';
import {
  getVideoIds,
  getCurrentVideoIndex,
} from '../../../redux/lazy-channel-videos/selectors';
import { isShareOverlayOpen } from '../../../selectors/share-overlay';
import { isPlayerActive } from '../../../selectors/layout';
import { withPlayerModuleLoader } from '../../../data-components/player-module-loader';
import ResponsiveLightbox from '../../components/responsive-lightbox/responsive-lightbox';
import {
  isInfoPanelVisible,
  isVideoListVisible,
} from '../../ui-selectors/blocks-visibility';
import {
  isVideoPlayingOptimistic,
  isVideoPlaying,
  isVideoPausedOptimistic,
} from '../../../selectors/video-playback-status';
import { isMobile } from '../../../selectors/form-factor';
import LiveStartHandler from '../../../components/live-start-handler/live-start-handler';
import { playVideo } from '../../../redux/actions/player/change-playback-status';
import {
  closeShareOverlay,
  toggleShareVideoOverlay,
} from '../../../redux/actions/share-overlay';
import { EXPANDED_THEME_VALUES } from '@wix/wix-vod-constants/app-settings';
import * as viewModeSelectors from '../../../selectors/view-mode';
import { PREVIEW_MODAL as PREVIEW_MODAL_HELP_ARTICLES } from '../../../constants/help-articles';
import { getWixSDK } from '../../../utils/wix-sdk';
import { openPlayerOverlay } from '../../../redux/player-overlay/actions/open-player-overlay';
import InFrameActionCallbacks from '../../../layouts/compact/actions/overlay-action-callbacks/in-frame';
import { notForPreview } from '../../../utils/not-for-preview';

let isContainerWasFocused = false;
const themes = {
  [EXPANDED_THEME_VALUES.LIGHT]: 'light',
  [EXPANDED_THEME_VALUES.DARK]: 'dark',
};

const mapStateToProps = (state, ownProps) => {
  const mainVideoId = state.selectedVideoId || ownProps.match.params.videoId;
  const videosByIds = getVideosGroupedByIds(state);
  const mainVideo = videosByIds[mainVideoId];

  return {
    mainVideoId,
    videosByIds,
    mainVideo,
    windowSize: state.windowSize,
    channel: getChannelForWidget(state),
    loadedVideoIds: getVideoIds(state),
    currentVideoIndex: getCurrentVideoIndex(state),
    currentSiteUser: getCurrentSiteUser(state),

    isVideoPlayStarted: isVideoPlaying(state),
    isVideoPaused: isVideoPausedOptimistic(state),
    isVideoPlaying: isVideoPlayingOptimistic(state),
    isVideoInfoVisible: isInfoPanelVisible(state),
    isVideoListVisible: isVideoListVisible(state),
    isVideoShareVisible: canShowExpandedVideoShare(state),
    isShareOverlayOpen: isShareOverlayOpen(state),
    isPlayerActive: isPlayerActive(state),
    isRTL: isRTL(state),
    theme: getExpandedViewTheme(state),
    isEditor: viewModeSelectors.isEditorMode(state),
    isMainActionsOnlyIcons: isCompactMainActionsOnlyIcons(state),
    isMobile: isMobile(state),
  };
};

const mapDispatchToProps = {
  storeForReload,
  playVideo,
  closeShareOverlay,
  logWidgetVidClick,
  openFullScreenOverlay,
  openPlayerOverlay,
  toggleShareVideoOverlay,
};

export const Lightbox = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class Lightbox extends React.Component {
    static propTypes = {
      channel: PropTypes.object.isRequired,
      mainVideoId: PropTypes.string.isRequired,
      videosByIds: PropTypes.object.isRequired,
      windowSize: PropTypes.object.isRequired,
      currentSiteUser: PropTypes.object,
      mainVideo: PropTypes.object,
      loadedVideoIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      currentVideoIndex: PropTypes.number.isRequired,

      isChannelView: PropTypes.bool.isRequired,
      isVideoPlayStarted: PropTypes.bool.isRequired,
      isVideoPaused: PropTypes.bool.isRequired,
      isVideoPlaying: PropTypes.bool.isRequired,
      isVideoInfoVisible: PropTypes.bool.isRequired,
      isVideoListVisible: PropTypes.bool.isRequired,
      isVideoShareVisible: PropTypes.bool.isRequired,
      isShareOverlayOpen: PropTypes.bool.isRequired,
      isPlayerActive: PropTypes.bool.isRequired,
      isRTL: PropTypes.bool,
      isEditor: PropTypes.bool.isRequired,
      isMainActionsOnlyIcons: PropTypes.bool.isRequired,

      theme: PropTypes.oneOf([
        EXPANDED_THEME_VALUES.DARK,
        EXPANDED_THEME_VALUES.LIGHT,
      ]).isRequired,

      prevVideoId: PropTypes.string,
      nextVideoId: PropTypes.string,

      playVideo: PropTypes.func.isRequired,
      closeShareOverlay: PropTypes.func.isRequired,
      close: PropTypes.func.isRequired,
      openPlayerOverlay: PropTypes.func.isRequired,
      toggleShareVideoOverlay: PropTypes.func.isRequired,

      PlayerComponent: PropTypes.func,
    };

    componentDidMount() {
      // This and at componentDidUpdate - is a hack to change main item by keyboard arrows
      // (need to focus some element at current document after external player iFrame rendering)
      // if not play requested - focus right now, else - wait for play start
      if (!this.props.isVideoPlaying) {
        this.focusContainer();
      }
      this.setHelpArticle();
    }

    componentDidUpdate(prevProps) {
      if (
        !isContainerWasFocused &&
        !prevProps.isVideoPlayStarted &&
        this.props.isVideoPlayStarted
      ) {
        setTimeout(this.focusContainer);
      }
    }

    setHelpArticle() {
      if (this.props.isEditor) {
        getWixSDK().Settings.setHelpArticle(PREVIEW_MODAL_HELP_ARTICLES, {
          type: 'MODAL',
        });
      }
    }

    focusContainer = () => {
      isContainerWasFocused = true;
      focus(this.containerRef);
    };

    showAccountInfoAtOverlay = () => {
      this.props.openFullScreenOverlay(
        `#/account-info/${this.props.channel.id}?isLightbox=true`,
      );
    };

    sendWidgetVidClickedBi = (videoItem) => {
      const { channel, logWidgetVidClick, fedops, isMobile } = this.props;

      logWidgetVidClick({ videoItem, channelData: channel });
    };

    storeDataForReload = () => {
      this.props.storeForReload({
        selectedVideoId: this.props.mainVideoId,
      });
    };

    handleCloseButtonClick = () => this.props.close();

    showPurchaseInfoAtOverlay = notForPreview((video) => {
      const { openPlayerOverlay, fedops } = this.props;
      openPlayerOverlay(fedops, video);
    });

    playVideo = (video) => this.props.playVideo(video.id);

    handleChannelClick = () => {
      const { history, channel } = this.props;
      history.push(`/channel/${channel.id}`);
    };

    renderResponsive() {
      const {
        mainVideo,
        channel,
        theme,
        isChannelView,
        isVideoInfoVisible,
        isPlayerActive,
        isRTL,
        isVideoShareVisible,
        isVideoListVisible,
        currentSiteUser,
        isMainActionsOnlyIcons,
        PlayerComponent,
        toggleShareVideoOverlay,
      } = this.props;

      const view = (
        <ResponsiveLightbox
          isChannelView={isChannelView}
          mainVideo={mainVideo}
          channel={channel}
          currentSiteUser={currentSiteUser}
          theme={theme}
          isVideoInfoVisible={isVideoInfoVisible}
          isMainActionsOnlyIcons={isMainActionsOnlyIcons}
          isPlayerActive={isPlayerActive}
          isRTL={isRTL}
          isVideoShareVisible={isVideoShareVisible}
          isVideoListVisible={isVideoListVisible}
          PlayerComponent={PlayerComponent}
          onShareClick={toggleShareVideoOverlay}
          onCloseClick={this.handleCloseButtonClick}
          onPlayRequestedBi={this.sendWidgetVidClickedBi}
          onPurchaseClick={this.showPurchaseInfoAtOverlay}
          onPageRefresh={this.storeDataForReload}
          onAccountClick={this.showAccountInfoAtOverlay}
          onChannelClick={this.handleChannelClick}
        />
      );

      return (
        <div
          data-hook="wix-vod-widget-theme-container"
          data-theme={themes[theme]}
        >
          {isChannelView ? (
            view
          ) : (
            <InFrameActionCallbacks
              channelId={channel.id}
              videoId={mainVideo.id}
              videoSource={mainVideo.videoSource}
              onPlayRequestedBi={_.partial(
                this.sendWidgetVidClickedBi,
                mainVideo,
              )}
              key={mainVideo.id}
            >
              {view}
            </InFrameActionCallbacks>
          )}
        </div>
      );
    }

    render() {
      const { mainVideoId, isVideoPlaying, isVideoPaused } = this.props;

      return (
        <React.Fragment>
          {this.renderResponsive()}
          <LiveStartHandler
            playVideo={this.playVideo}
            isVideoPlaying={isVideoPlaying || isVideoPaused}
            selectedVideoId={mainVideoId}
          />
        </React.Fragment>
      );
    }
  },
);

export default withFedopsLogger(withPlayerModuleLoader(Lightbox));
